export enum StudyOrgStatusType {
  STUDY_CLOSE_OUT_PERIOD = 'STUDY_CLOSE_OUT_PERIOD',
}
